import React, { forwardRef } from 'react';
export const AccordionIcon = (StyledAccordionIcon) => forwardRef((props, ref) => {
    return <StyledAccordionIcon {...props} ref={ref}/>;
});
